
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyback-cars",
      function () {
        return require("private-next-pages/buyback-cars.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyback-cars"])
      });
    }
  